import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PersonSearchService } from '../_services/person-search.service';

@Component({
  selector: 'app-save-search-modal',
  templateUrl: './save-search-modal.component.html',
  styleUrls: ['./save-search-modal.component.scss']
})
export class SaveSearchModalComponent implements OnInit {

  constructor(private activeModal: NgbActiveModal, private personSearchService: PersonSearchService) { }

  @Input() talentdiscoveryhistoryid: string | number = null;
  @Input() searchName: string = null;

  saveSearchForm: FormGroup = new FormGroup({
    searchname: new FormControl(null, Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(150), Validators.pattern(/^\s*\S.*\S\s*$/)]))
  });

  ngOnInit() {
    if(this.searchName) {
      this.saveSearchForm.patchValue({
        searchname: this.searchName.trim()
      }, { emitEvent: false });
      this.checkSearchNameDuplicacy();
    }
  }

  closeModal(type: string, message?: any) {
    if(type == 'error') {
      this.activeModal.dismiss(message);
    } else {
      this.activeModal.close(type == 'skip' ? 'user-dismissed' : message ? message : null);
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  checkSearchNameDuplicacy() {
    this.validateAllFormFields(this.saveSearchForm);
    
    const searchname: string = this.saveSearchForm.getRawValue()?.searchname?.trim();
    if(!this.saveSearchForm.valid) return;
    if(this.searchName && (this.searchName === searchname)) return;

    if(!(searchname && searchname.length > 1)) return;

    this.personSearchService.checkSearchNameDuplicacy(searchname).subscribe((res: any) => {
      if(res && res.status === 'success') {
        if(res.duplicate) {
          this.saveSearchForm.controls['searchname'].setErrors({ ...this.saveSearchForm.controls['searchname'], duplicate: true });
        } else {
          this.saveSearchForm.controls['searchname'].errors && delete this.saveSearchForm.controls['searchname'].errors['duplicate']
        }
      } else {
        this.saveSearchForm.controls['searchname'].errors && delete this.saveSearchForm.controls['searchname'].errors['duplicate']
      }
    }, (err: any) => {
      console.log("checkSearchNameDuplicacy() error - ", err);
    })
  }

  saveSearch() {
    this.validateAllFormFields(this.saveSearchForm);

    if(this.saveSearchForm.valid) {
      const formValues = this.saveSearchForm.getRawValue();
      const payload = {
        talentdiscoveryname: formValues?.searchname?.trim(),
        talentdiscoveryhistoryid: this.talentdiscoveryhistoryid
      }

      this.personSearchService.saveSearch(payload).subscribe((res: any) => {
        if(res && res.status === 'success') {
          this.closeModal('success', 'Saved successfully');
        } else {
          this.closeModal('error');
        }
      }, (err: any) => {
        console.log("saveSearch() err - ", err);
        this.closeModal('error', err);
      })
    }
  }

}
